//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rooms-selector',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultNum: {
      type: Number | String,
      default: 1,
    },
    surplusRoom: {
      type: Number | String,
      default: 0,
    },
    ableToChangeRoom: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      show: this.value,
      iNow: +this.defaultNum,
    };
  },
  watch: {
    value(cur, old){
      this.show = cur;
    },

    defaultNum(cur){
      this.iNow = Number(cur);
    },
  },
  methods: {
    onSelectNumber(ev, num){
      if(this.ableToChangeRoom){
        this.iNow = num;
        this.$emit('on-select-rooms', num);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/RoomsSelector.vue